import { Container, FormHelperText, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import { Form, Formik } from 'formik';
import React, { useRef, useState } from 'react';
import { Yup } from '../utils/form-utils';
import InputWithFormik from './inputs/InputWithFormik';
import NumberInput from './inputs/NumberInput';
import NumeroGuiaInput from './inputs/NumeroGuiaInput';

const styles = theme => ({
  buttons: {
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  innerContainer: {
    paddingTop: theme.spacing(2)
  }
});

const validationSchema = Yup.object().shape({
  pesoTarifado: Yup.string().required(),
  totalFlete: Yup.string().required(),
  cantidadBultos: Yup.string().required(),
  nroGuia: Yup.string()
    .matches(/^[A-Z]{2}\d{9}PY$/, 'Debe seguir el formato EE123456789PY')
    .required('El número de guía es obligatorio')
});

const Confirm = ({ onConfirm, onClose, open, classes, email = true }) => {
  const formik = useRef();
  const onSubmit = values => {
    if (onConfirm) {
      onConfirm(values);
    }
    if (onClose) {
      onClose();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Admitir formulario'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          La información a ser enviada tiene carácter de declaración jurada y ya
          no podrá ser modificada
        </DialogContentText>
        {email && (
          <DialogContentText>
            Se enviará un comprobante al correo electrónido de notificación
            indicado en el formulario
          </DialogContentText>
        )}
        <Formik
          enableReinitialize
          initialValues={{
            ...{
              pesoTarifado: '',
              totalFlete: '',
              cantidadBultos: '',
              nroGuia: ''
            }
          }}
          innerRef={formik}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {() => (
            <Form id="miForm" name="miForm" noValidate>
              {/* <FormikSubmitEffect onSubmitError={onSubmitError} /> */}
              <Container maxWidth="md" className={classes.innerContainer}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <InputWithFormik
                      label="Peso tarifado (Kg.)"
                      name="pesoTarifado"
                      required
                      InputProps={{
                        inputComponent: NumberInput
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputWithFormik
                      required
                      label="Flete facturado (Gs.)"
                      name="totalFlete"
                      InputProps={{
                        inputComponent: NumberInput,
                        inputProps: { decimalScale: 0 }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputWithFormik
                      label="Cantidad de bultos"
                      name="cantidadBultos"
                      required
                      InputProps={{
                        inputComponent: NumberInput,
                        inputProps: { decimalScale: 0 }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputWithFormik
                      required
                      label="Nro. de guía"
                      name="nroGuia"
                      tooltip="Se debe incluir el número de guía"
                      InputProps={{ inputComponent: NumeroGuiaInput }}
                      inputProps={{ style: { textTransform: 'uppercase' } }}
                    />
                    <FormHelperText variant="outlined">
                      Número guía de ejemplo: EE123456789PY
                    </FormHelperText>
                  </Grid>
                </Grid>
              </Container>
            </Form>
          )}
        </Formik>
      </DialogContent>
      <DialogActions className={classes.buttons}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancelar
        </Button>
        <Button
          type="submit"
          form="miForm"
          color="primary"
          variant="contained"
          autoFocus
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ConfirmDeleteDialog = props => {
  const { open, toggle, confirm, classes } = props;
  const [acepto, setAcepto] = useState(false);
  return (
    <Dialog
      open={open}
      onClose={() => {
        toggle();
        setAcepto(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'¿Está seguro(a)?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          La soliciltud se anulará definitivamente y no podrá ser recuperada
        </DialogContentText>
        <FormControlLabel
          control={
            <Checkbox
              checked={acepto}
              onChange={event => setAcepto(event.target.checked)}
              name="checkedB"
              color="primary"
            />
          }
          label="Anular de todos modos"
        />
      </DialogContent>
      <DialogActions className={classes.buttons}>
        <Button
          onClick={() => {
            toggle();
            setAcepto(false);
          }}
          color="secondary"
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button
          onClick={() => {
            confirm();
            toggle();
          }}
          color="primary"
          variant="contained"
          autoFocus
          disabled={!acepto}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ConfirmDelete = withStyles(styles)(ConfirmDeleteDialog);
export default withStyles(styles)(Confirm);
